import React from "react";

export const RouterContext = React.createContext(null);

export default function useRouterContext() {
	const context = React.useContext(RouterContext);

	if (!context) {
		throw new Error(
			"[useRouterContext] Did you use RouterContext outside a RouterContextProvider?"
		);
	}

	return context;
}
